"use client"
import styles from "../../styles/finder/finder.module.scss"
import { useEffect, useState } from "react"
import StepBar from "src/components/StepBar/StepBar"
import BehindNavBar from "src/components/BehindNavBar/BehindNavBar"
import Button from "src/components/Button/Button"
import Step1 from "src/components/finder/steps/Step1"
import Step2a from "src/components/finder/steps/Step2a"
import { STEPS, useUserStore, useWizardStore } from "src/components/finder/store/finder_store"
import Step2b from "src/components/finder/steps/Step2b"
import Step3b from "src/components/finder/steps/Step3b"
import Step3c from "src/components/finder/steps/Step3c"
import { fetchLocation } from "src/components/finder/store/nominatim"
import { toast } from "react-toastify"
import { postDermatologistInterest, updateDermatologistInterest } from "src/api/skinuvita-finder-api"
import { AxiosError, AxiosResponse } from "axios"
import { ApiError } from "next/dist/server/api-utils"
import {  indications } from "src/components/finder/steps/insurances"
import Footer from "src/components/footer"
import { sendGTMEvent } from "@next/third-parties/google"
import Step3a from "src/components/finder/steps/Step3a"
import NavBarNotOnHomepage from "src/components/LandingPage/navbars/NavBarNotOnHomepage"
import SkinuvitaSeoHead from "../components/LandingPage/SkinuvitaSeoHead"
import LanguageToggle from "src/components/LanguageToggle"
import { useTranslations } from "next-intl"
import { Routes, useTypedRouter } from "../data/routes"
import Image from "next/image"
import { TrackedActions } from "../tracking/trackedActions"

export type ActiveHealthInsuranceItem = {
  insurance_key: string
  insurance_id: number
  name: string
  is_active: boolean
  partner_since: string
  last_updated: string
  updated_by: string
  covered_indications: string[]
}



const Finder = ({ partnerInsurances = [] }: { partnerInsurances?: ActiveHealthInsuranceItem[] }) => {
  const t = useTranslations("index.finder")
  const router = useTypedRouter()
  const [isStep1ButtonDisabled, setIsStep1ButtonDisabled] = useState<boolean>()
  const [isStep2aButtonDisabled, setIsStep2aButtonDisabled] = useState<boolean>()
  const [isStep2bButtonDisabled, setIsStep2bButtonDisabled] = useState<boolean>()
  const [isStep3aButtonDisabled, setIsStep3aButtonDisabled] = useState<boolean>()
  const [drawerOpen, setDrawerOpen] = useState(false)
  const resetUserStore = useUserStore((state) => state.resetUserStore)
  const userStore = useUserStore()
  const wizardStore = useWizardStore()
  const { step, setStep } = wizardStore
  useEffect(() => {
    sendGTMEvent({
      event: "conversion",
      send_to: "AW-17155777045/3vCYCP_6v-YaEJXEwfQ_",
      value: 1.0,
      currency: "EUR",
    })
  }, [])

  function findInsuranceByName(name) {
    return partnerInsurances.find(
      (insurance) => insurance.name.toLowerCase() === name.toLowerCase()
    )
  }
  function checkIfDiagnoseIsCovered(diagnoses: indications[], insuranceName: string): boolean {
    const insurance = findInsuranceByName(insuranceName)
    if (!insurance) {
      console.error(`Insurance with name "${insuranceName}" not found.`)
      return false
    }

    return diagnoses.some((diagnosis) => insurance.covered_indications.includes(diagnosis))
  }

  function handleFinderForwardNavigation() {
    switch (step) {
      case STEPS.diagnoseAndInsurance:
        const selectedInsurance = findInsuranceByName(userStore.healthInsurance)
        if (selectedInsurance.is_active && checkIfDiagnoseIsCovered(userStore.diagnoses, userStore.healthInsurance)) {
          setStep(STEPS.fittingInsurance)
        } else {
          setStep(STEPS.unfittingInsurance)
        }
        break

      case STEPS.fittingInsurance:
          TrackedActions.confirmMatchingLead(userStore).then((data) => {
                userStore.setNominatimResponse(data)
                setStep(STEPS.doctorsOfficeClose)

          })
        // toast.promise(
        //   {
        //     pending: t("messages.searching"),
        //     success: {
        //       render({ data }) {
        //         return t("messages.found")
        //       },
        //     },
        //     error: t("messages.zipNotFound"),
        //   },
        //   { hideProgressBar: true }
        // )
        break

      case STEPS.unfittingInsurance:

        toast.promise<AxiosResponse, ApiError>(
          TrackedActions.confirmUnfittingLead(userStore),
          {
            pending: t("messages.loading"),
            success: {
              render({ data }) {
                setTimeout(() => setStep(STEPS.confirmationUnfitting), 100)
                // setTimeout(() => router.replace(Routes.home), 250)
                // setTimeout(() => setStep(STEPS.diagnoseAndInsurance), 100)
                return t("messages.successSent")
              },
            },
            error: {
              render({ data }) {
                console.error("Fehler beim Senden der Daten:", data)
                return data?.message || t("messages.errorSending")
              },
            },
          },
          { hideProgressBar: true }
        )
        break

      case STEPS.doctorsOfficeClose:
        toast.promise<AxiosResponse, AxiosError>(
          updateDermatologistInterest(userStore.uuid, {
            requestsHelpForFindingDermatologist: true,
          }),
          {
            pending: t("messages.loading"),
            success: {
              render({ data }) {
                setTimeout(() => setStep(STEPS.helpWasAskedFor), 100)
                return t("messages.successSent")
              },
            },
            error: {
              render({ data }) {
                console.error("Fehler beim Senden der Daten:", data)
                return data?.message || t("messages.errorSending")
              },
            },
          },
          { hideProgressBar: true }
        )
        break

      case STEPS.helpWasAskedFor:
      default:
        break
    }
  }

  function handleFinderBackNavigation() {
    switch (step) {
      case STEPS.diagnoseAndInsurance:
        break
      case STEPS.fittingInsurance:
      case STEPS.unfittingInsurance:
        setStep(STEPS.diagnoseAndInsurance)
        break
      case STEPS.helpWasAskedFor:
        setStep(STEPS.doctorsOfficeClose)
        break
      case STEPS.doctorsOfficeClose:
        setStep(STEPS.fittingInsurance)
        break
    }
  }

  function getCurrentStepForStepBar(): 1 | 2 | 3 {
    switch (step) {
      case STEPS.diagnoseAndInsurance:
        return 1
      case STEPS.fittingInsurance:
      case STEPS.unfittingInsurance:
        return 2
      case STEPS.helpWasAskedFor:
      case STEPS.doctorsOfficeClose:
      default:
        return 3
    }
  }

  function getTextForButton() {
    switch (step) {
      case STEPS.diagnoseAndInsurance:
        return t("buttons.check")
      case STEPS.fittingInsurance:
        return t("buttons.searchPractice")
      case STEPS.unfittingInsurance:
        return t("buttons.sendContactData")
      case STEPS.helpWasAskedFor:
      default:
        return null
    }
  }

  function getIdForButton() {
    switch (step) {
      case STEPS.diagnoseAndInsurance:
        return "diagnoseAndInsurance"
      case STEPS.fittingInsurance:
        return "fittingInsurance"
      case STEPS.unfittingInsurance:
        return "unfittingInsurance"
      case STEPS.helpWasAskedFor:
        return "helpWasAskedFor"
      case STEPS.doctorsOfficeClose:
        return "noDoctorsOfficeClose"
      default:
        return null
    }
  }

  useEffect(() => {
    if (step != STEPS.diagnoseAndInsurance) {
      history.pushState({ step: step }, "")
    } else {
      history.replaceState({ step: step }, "")
    }
  }, [step])

  useEffect(() => {
    const handleBackButton = () => {
      if (step != STEPS.diagnoseAndInsurance) {
        handleFinderBackNavigation()
      } else {
        window.removeEventListener("popstate", handleBackButton)
      }
    }

    window.addEventListener("popstate", handleBackButton)
    return () => window.removeEventListener("popstate", handleBackButton)
  }, [step])

  useEffect(() => {
    console.log("step", step)
  }, [step])
  return (
    <div className={styles.root}>
      <SkinuvitaSeoHead
        title={`${t("seo.title")} | Skinuvita`}
        description={t("seo.description")}
        canonicalPath={Routes.selfCheck}
      />
      <div>
        <NavBarNotOnHomepage />
        <BehindNavBar />

        <div className={styles.finderContainer}>
          <Button
            variant={"text"}
            style={{
              fontSize: "16px",
              paddingTop: "8px",
              paddingBottom: "8px",
              paddingRight: "16px",
              paddingLeft: "8px",
              textDecoration: "underline",
              gap: "8px",
            }}
            onClick={
              step === STEPS.confirmationUnfitting || step === STEPS.helpWasAskedFor
                ? () => {
                    resetUserStore()
                    setStep(STEPS.diagnoseAndInsurance)
                    router.push(Routes.home)
                  }
                : step === STEPS.diagnoseAndInsurance
                ? () => router.push(Routes.home)
                : () => handleFinderBackNavigation()
            }
          >
            {step !== STEPS.diagnoseAndInsurance && step !== STEPS.confirmationUnfitting && (
              <Image src="/svg/arrows.svg" alt="back" width={16} height={16} />
            )}

            {step === STEPS.confirmationUnfitting ||
            step === STEPS.helpWasAskedFor ||
            step === STEPS.diagnoseAndInsurance
              ? t("ui.close")
              : t("ui.back")}
          </Button>
          <StepBar
            style={{ marginBottom: "16px" }}
            currentStep={
              step === STEPS.unfittingInsurance || step === STEPS.confirmationUnfitting ? 2 : getCurrentStepForStepBar()
            }
            steps={
              step === STEPS.unfittingInsurance || step === STEPS.confirmationUnfitting
                ? [t("ui.step1"), t("ui.step2")]
                : [t("ui.step1"), t("ui.step2"), t("ui.step3")]
            }
          />
          {step == STEPS.diagnoseAndInsurance && (
            <Step1 partnerInsurances={partnerInsurances} onDisabledChange={setIsStep1ButtonDisabled} />
          )}
          {step == STEPS.fittingInsurance && <Step2a onDisabledChange={setIsStep2aButtonDisabled} />}
          {step == STEPS.unfittingInsurance && <Step2b onDisabledChange={setIsStep2bButtonDisabled} />}
          {step == STEPS.helpWasAskedFor && <Step3a onDisabledChange={setIsStep3aButtonDisabled} />}
          {step == STEPS.doctorsOfficeClose && <Step3b onDisabledChange={setIsStep2aButtonDisabled} />}
          {step == STEPS.confirmationUnfitting && <Step3c />}
          {step !== STEPS.helpWasAskedFor &&
            step !== STEPS.doctorsOfficeClose &&
            step !== STEPS.confirmationUnfitting && (
              <div className={styles.buttonGroup}>
                <Button
                  className={styles.nextButton}
                  id={getIdForButton()}
                  variant={"primary"}
                  disabled={
                    (isStep1ButtonDisabled && step == STEPS.diagnoseAndInsurance) ||
                    (isStep2aButtonDisabled && step == STEPS.fittingInsurance) ||
                    (isStep2bButtonDisabled && step == STEPS.unfittingInsurance)
                  }
                  onClick={handleFinderForwardNavigation}
                >
                  {getTextForButton()}
                </Button>
              </div>
            )}
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Finder
